import { useEffect, useRef, memo } from 'react';

const CanvasFeather = () => {
  const ref = useRef(null);

  useEffect(() => {
    let fps = 30;
    let now;
    let then = Date.now();
    let interval = 1000 / fps;
    let delta;

    // canvas init
    let canvas = ref.current;
    let ctx = canvas.getContext('2d');

    // canvas dimensions
    let W = window.innerWidth;
    let H = window.innerHeight;
    canvas.width = W;
    canvas.height = H;

    // snowflake particles
    let mp = 12; // max particles
    let particles = [];
    for (let i = 0; i < mp; i++) {
      particles.push({
        x: Math.random() * W, // x-coordinate
        y: Math.random() * H, // y-coordinate
        r: Math.random() * 4 + 1, // radius
        // d: Math.random() * mp // random density
        d: mp, // density
      });
    }

    let pArr = [];
    for (let xx = 0; xx < 4; xx++) {
      let _img = new Image();
      _img.src = `//blcdnsmall.nikkigames.cn/sdk/poster/evolweb/secondary/particles/feather${xx}.png`;
      pArr.push(_img);
    }

    // angle will be an ongoing incremental flag.
    // Sin and Cos functions will be applied to it to create vertical and horizontal movements of the flakes
    let angle = 0;

    // Function to move the snowflakes
    function update() {
      angle += 0.01;
      for (let i = 0; i < mp; i++) {
        let p = particles[i];
        // Updating X and Y coordinates
        // We will add 1 to the cos function to prevent negative values which will lead flakes to move upwards
        // Every particle has its own density which can be used to make the downward movement different for each flake
        // Lets make it more random by adding in the radius
        p.y += Math.cos(angle + p.d) + 1 + p.r / 2;
        p.x += Math.sin(angle) * 2;

        // Sending flakes back from the top when it exits
        // Lets make it a bit more organic and let flakes enter from the left and right also.
        if (p.x > W + 5 || p.x < -5 || p.y > H) {
          // 66.67% of the flakes
          if (i % 3 > 0) {
            particles[i] = { x: Math.random() * W, y: -10, r: p.r, d: p.d };
          } else if (Math.sin(angle) > 0) {
            // Enter from the left
            particles[i] = { x: -5, y: Math.random() * H, r: p.r, d: p.d };
          } else {
            // Enter from the right
            particles[i] = { x: W + 5, y: Math.random() * H, r: p.r, d: p.d };
          }
        }
      }
    }

    // Lets draw the flakes
    function draw2() {
      ctx.clearRect(0, 0, W, H);

      ctx.beginPath();
      for (let j = 0; j < 3 && j < mp; j++) {
        let pf = particles[j];
        let img = pArr[j];
        ctx.drawImage(img, pf.x, pf.y, img.width, img.height);
      }

      ctx.fillStyle = 'rgba(255, 255, 255, 1)';
      for (let i = 3; i < mp; i++) {
        let p = particles[i];
        ctx.moveTo(p.x, p.y);
        ctx.arc(p.x, p.y, p.r * 0.39, 0, Math.PI * 2, true);
      }
      ctx.fill();
      // 计算下一次移动位置
      update();
    }

    function tick2() {
      requestAnimationFrame(tick2);
      now = Date.now();
      delta = now - then;
      if (delta > interval) {
        // 这里不能简单then=now，否则还会出现上边简单做法的细微时间差问题。
        // 例如fps=10，每帧100ms，而现在每16ms（60fps）执行一次draw。16*7=112>100，需要7次才实际绘制一次。这个情况下，实际10帧需要112*10=1120ms>1000ms才绘制完成。
        then = now - (delta % interval);
        draw2(); // ... Code for Drawing the Frame ...
      }
    }
    tick2();
  }, []);

  return (
    <div style={{ position: 'absolute', pointerEvents: 'none', zIndex: '2' }}>
      <canvas ref={ref} />
    </div>
  );
};

export default memo(CanvasFeather);
